import React from "react";
import { Fan } from "@/services/bedrock";
import { FormRequestDialog } from "../../Forms/components/FormRequestDialog";

interface FanFormRequestDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fan: Fan | null;
}

/** Fan Zone's "Request feedback": the Forms tab's link dialog with the Fan fixed and a form to pick. */
export function FanFormRequestDialog({ open, onOpenChange, fan }: FanFormRequestDialogProps) {
  return <FormRequestDialog open={open} onOpenChange={onOpenChange} form={null} fan={fan} />;
}
